import { Navigate, useLocation } from 'react-router-dom';
import { Flex, Spin, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuth } from './AuthProvider';
import { subjectOf, type AccessSubject } from './access';
export function RequireAuth({
  children,
  loginPath,
}: {
  children: React.ReactNode;
  loginPath: string;
}) {
  const { me, ready } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();
  if (!ready) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: '100vh' }}>
        <Spin size="large" description={t('common.loading')} />
      </Flex>
    );
  }
  if (me === null) {
    return (
      <Navigate to={loginPath} state={{ from: location.pathname + location.search }} replace />
    );
  }
  return <>{children}</>;
}
export function RequireAccess({
  allow,
  children,
}: {
  allow: (subject: AccessSubject) => boolean;
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  const { me } = useAuth();
  if (me === null) return null;
  if (allow(subjectOf(me))) return <>{children}</>;
  return (
    <Flex align="center" justify="center" style={{ minHeight: '60vh' }}>
      <Typography.Text type="secondary">{t('app.forbidden')}</Typography.Text>
    </Flex>
  );
}
